import AmellisHealth from "./AmellisHealth";
import Health from "./Health";
import Lafourgale from "./Lafourgale";
import LmfHealth from "./LmfHealth";
import Miltis from "./Miltis";
import MutualMobility from "./MutualMobility";
import SmartPhone from "./SmartPhone";
import SNCA from "./SNCA";
import SoLyonHealth from "./SoLyonHealth";
import MCCI from "./MCCI";
import Acoris from "./Acoris";

const Templates = {
  Health,
  SmartPhone,
  SoLyonHealth,
  LmfHealth,
  MutualMobility,
  AmellisHealth,
  Miltis,
  SNCA,
  Lafourgale,
  MCCI,
  Acoris,
};

export default Templates;
